import React, { useState } from "react";
import { Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { Button } from "antd";
import SessionDetails from "./SessionDetails";
import GoalsFromFileResponseMessage from "./GoalsFromFileResponseMessage";
import { baseURL } from "../../utils/config";
import Cookies from "js-cookie";

const Box = ({
  title,
  Click,
  icon,
  bgColor,
  borderColor,
  hoverBgColor,
  hoverBorderColor,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const boxStyle = {
    backgroundColor: isHovered ? hoverBgColor : bgColor,
    border: `1px solid ${isHovered ? hoverBorderColor : borderColor}`,
    transition: "background-color 0.3s, border-color 0.3s",
    boxShadow: isHovered ? "0px 0px 10px rgba(0, 0, 0, 0.1)" : "none",
  };

  return (
    <div
      onClick={Click}
      className="flex flex-col justify-between border-1 px-2 py-2 rounded-2xl cursor-pointer w-full md:w-1/3"
      style={boxStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <h2
        className="text-base font-medium text-center"
        style={{
          color: "#242222",
        }}
      >
        {title}
      </h2>
      <img
        src={icon}
        alt={title}
        className="mx-auto"
        style={{
          width: "63px",
          height: "63px",
        }}
      />
    </div>
  );
};

const MessageList = ({
  messages,
  handleSummary,
  handleGoal,
  handleDoc,
  data,
  isEditing,
  setIsEditing,
  openModal,
  handleFileChange,
  handleUploadDoc,
  selectedFileName,
  handleClose,
}) => {
  const [isHoveredButton, setIsHoveredButton] = useState(false);
  const userold = useSelector((state) => state.user);

  const handleDownloadExample = async () => {
    try {
      const token = Cookies.get("access_token");
      const response = await fetch(`${baseURL}/documents/goals-example`, {
        method: 'GET',
        headers: {
          'Authorization': token,
        },
      });
      
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'goals-example.docx';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        console.error('Failed to download file');
      }
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  return (
    <div className="flex flex-col w-full space-y-4 py-2 h-full px-4">
      {/* No messages and modal closed */}
      {messages?.length === 0 && !openModal && (
        <div className="flex flex-col justify-center sm:flex-row w-full sm:justify-evenly space-y-4 sm:space-x-4 sm:space-y-0 p-4">
          {data && (
            <Box
              title="Summarize"
              Click={handleSummary}
              bgColor="#FDF6E3"
              icon="/assets/images/ChatSummarize.png"
              borderColor="rgb(240, 182, 27, 0.17)"
              hoverBgColor="#FFF1CD"
              hoverBorderColor="rgb(240, 182, 27,0.39)"
            />
          )}
          {userold?.roleAccess?.Goals?.Create && (
            <>
              <Box
                title="Create Goal"
                Click={handleGoal}
                bgColor="#FFF6F6"
                icon="/assets/images/chatgoal.png"
                borderColor="rgba(233, 68, 68, 0.17)"
                hoverBgColor="#FEEEEE"
                hoverBorderColor="rgb(233, 68, 68,0.3)"
              />
              <Box
                title="Create Goals from a Document"
                Click={handleDoc}
                bgColor="#ECF6FF"
                icon="/assets/images/chatgoaldoc.png"
                borderColor="rgb(0, 70, 146, 0.17)"
                hoverBgColor="#D2EAFF"
                hoverBorderColor="rgb(0, 70, 146,0.3)"
              />
            </>
          )}
        </div>
      )}

      {/* No messages and modal open */}
      {messages?.length === 0 && openModal && (
        <div className="flex items-center justify-center h-full w-full">
          <div className="flex flex-col w-full sm:w-2/3 p-1 h-2/3">
            <div className="bg-gray-50 rounded flex flex-col items-center h-full justify-evenly p-1 border-2 border-dashed">
              <img src="/assets/images/DocUpload.png" className="w-14 h-14" />
              <p className="text-lg text-basic">Upload A Document</p>
              <label className="text-md font-medium px-2 flex justify-between">
                <div className="relative border bg-button hover:bg-button-hover border-gray-300 rounded-md py-2 px-10 flex items-center justify-between w-full">
                  <span className="text-white mr-2">
                    {selectedFileName?.name
                      ? selectedFileName?.name
                      : "Select Document"}
                  </span>
                  <input
                    type="file"
                    className="absolute inset-0 opacity-0 z-10 w-full h-full cursor-pointer"
                    accept=".pdf,.doc,.docx"
                    onChange={handleFileChange}
                  />
                </div>
              </label>
              <p className="p-1 text-xs text-center text-red-500">
                We accept (pdf and docx) files only. Maximum size of the file
                should be 1 mb.
              </p>
              <div className="mt-2 text-center">
                <button 
                  onClick={handleDownloadExample}
                  className="text-blue-500 hover:text-blue-700 underline flex items-center justify-center mx-auto"
                  title="Click to download the Q1 2027 OKR template. Edit each goal, objective, and key result to match your team’s quarterly priorities."
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                  Download our goals template
                </button>
              </div>
            </div>
            <div className="mt-3 flex items-center justify-end col-span-6 gap-x-4">
              <Button onClick={handleDoc}>Cancel</Button>
              <Button
                disabled={!selectedFileName?.name}
                onClick={handleUploadDoc}
                onMouseEnter={() => setIsHoveredButton(true)}
                onMouseLeave={() => setIsHoveredButton(false)}
                style={{
                  backgroundColor: !selectedFileName?.name
                    ? "#1890ff"
                    : isHoveredButton
                    ? "#0050b3"
                    : "#1890ff",
                  color: "white",
                  borderColor: "#1890ff",
                  cursor: !selectedFileName?.name ? "not-allowed" : "pointer",
                }}
              >
                Upload
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Messages section */}
      {messages?.length === 0 && !openModal ? (
        <div className="flex justify-center items-center h-full">
          <div className="flex flex-col space-y-4 items-center">
            <p className="text-2xl font-medium font-poppins">
            Hi! I'm Joyce, your virtual assistant
            </p>
            <p className="text-base font-poppins">
            You can ask me questions about our OKR solution
            </p>
          </div>
        </div>
      ) : (
        messages?.map((message, index) => (
          <React.Fragment key={index}>
            <div className="bg-blue-500 mt-2 text-white rounded-lg p-3 max-w-xs self-end">
              {message?.query?.name || message?.query}
            </div>

            <div
              key={index + "_response"}
              className="bg-gray-200 flex justify-start text-gray-800 rounded-lg p-3 max-w-sm"
            >
              {message?.response ? (
                <Text as="p" whiteSpace="pre-line" className="w-full">
                  {message?.response?.response_type === "create_goal" ? (
                    <GoalsFromFileResponseMessage 
                      message={message} 
                      onClose={handleClose}
                    />
                  ) : message?.response?.response_type === "create_goal_single"? (
                    <SessionDetails
                      message={message?.response}
                      data={data}
                      isEditing={isEditing}
                      setIsEditing={setIsEditing}
                    />
                  ) : (
                    <p className="w-full">{message?.response}</p>
                  )}
                </Text>
              ) : (
                <div className="flex gap-2">
                  <div className="w-2 h-2 rounded-full animate-pulse bg-blue-600"></div>
                  <div className="w-2 h-2 rounded-full animate-pulse bg-blue-600"></div>
                  <div className="w-2 h-2 rounded-full animate-pulse bg-blue-600"></div>
                </div>
              )}
            </div>
          </React.Fragment>
        ))
      )}
    </div>
  );
};

export default MessageList;